import { Observable } from '../Observable';
import { createFind } from './find';
export function findIndex(predicate) {
    return function (source) { return new Observable(function (subscriber) { return createFind(predicate, 'index', source, subscriber); }); };
}
//# sourceMappingURL=findIndex.js.map